import { lazy as lazyImport } from 'utils/generic/lazy';
import { EMarketStatisticsTemplate } from 'interfaces/market-statistic';
import { EmptySkeleton } from './Templates/Empty/skeleton';
import { GoalScoredSkeleton } from './Templates/GoalScored/skeleton';
import { LastFiveMatchesAvgSkeleton } from './Templates/LastFiveMatchesAvg/skeleton';
import { LastFiveMeetingsSkeleton } from './Templates/LastFiveMeetings/skeleton';
import { ResultsSkeleton } from './Templates/Results/skeleton';

const { Results } = lazyImport(
  () =>
    import(
      /* webpackChunkName: "market-statistic-results" */ './Templates/Results'
    )
);

const { GoalScored } = lazyImport(
  () =>
    import(
      /* webpackChunkName: "market-statistic-goal-scored" */ './Templates/GoalScored'
    )
);

const { LastFiveMeetings } = lazyImport(
  () =>
    import(
      /* webpackChunkName: "market-statistic-last-five-meetings" */ './Templates/LastFiveMeetings'
    )
);

const { LastFiveMatchesAvg } = lazyImport(
  () =>
    import(
      /* webpackChunkName: "market-statistic-last-five-avg" */ './Templates/LastFiveMatchesAvg'
    )
);

const { Empty } = lazyImport(
  () =>
    import(/* webpackChunkName: "market-statistic-empty" */ './Templates/Empty')
);

export const templatesProps = {
  [EMarketStatisticsTemplate.GoalScored]: {
    view: GoalScored,
    skeleton: GoalScoredSkeleton
  },
  [EMarketStatisticsTemplate.Empty]: {
    view: Empty,
    skeleton: EmptySkeleton
  },
  [EMarketStatisticsTemplate.LastFiveMatchesAvg]: {
    view: LastFiveMatchesAvg,
    skeleton: LastFiveMatchesAvgSkeleton
  },
  [EMarketStatisticsTemplate.LastFiveMeetings]: {
    view: LastFiveMeetings,
    skeleton: LastFiveMeetingsSkeleton
  },
  [EMarketStatisticsTemplate.Results]: {
    view: Results,
    skeleton: ResultsSkeleton
  }
};
